module.exports = __webpack_public_path__ + "static/media/empty-state-topic.45d1a6a0.svg";